module.exports = __webpack_public_path__ + "img/plusAdd.3180c9de.svg";